import { Page, Container, ContentHeader } from 'components'
import { SubgroupsForm } from './components'

const SubgroupNew = () => {
  return (
    <Page title="Novo subgrupo">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader title="Novo" menu="Subgrupo" subtitle="Subgrupo" />
        <SubgroupsForm />
      </Container>
    </Page>
  )
}
export default SubgroupNew
